import { styled } from '@mui/material';
import { Skeleton } from '../Skeleton';

export const GridCellSkeleton = styled(Skeleton)({
  width: '100%',
  height: 0,
  paddingBottom: '100%',
  transform: 'unset',
});
